import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_426: DocMigration = {
  maxSchemaVersion: "0.0.426",
  description: "Add legacy facade corner board behavior flag",
  apply(json: any) {
    // look for facades applied to roofs
    const isRoofFacade: { [id: string]: boolean } = {};
    for (const roofId in json.roofs) {
      const { gableEndLabels } = json.roofs[roofId];
      if (!gableEndLabels) {
        continue;
      }

      for (const { facadeId } of gableEndLabels) {
        isRoofFacade[facadeId] = true;
      }
    }

    // set the legacy corner board behavior flag for the roof facades
    for (const facadeId in isRoofFacade) {
      const facade = json.facades[facadeId];
      if (!facade) {
        continue;
      }

      json.facades[facadeId] = {
        ...facade,
        legacyRoofCornerBoardBehavior: true,
      };
    }

    return json;
  },
};

export default migration_0_0_426;
